import Map from './Map.svelte'

const map = new Map({
    target: document.querySelector('.map-component'),
})

export default map
